import { combineReducers } from 'redux';
import form from './form';
import formModal from './formModal';

const appReducers = combineReducers({
  form,
  formModal,
});

export default appReducers;
